<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Receipt Summary") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">{{
                  $t("todate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getBoxOfficeReceiptReport"
            >
              {{ $t("fetch") }}
              
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="getBoxOfficeReport.length > 0"
        class="d-flex justify-content-end mt-3 mb-1 align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <a target="_blank" @click="generateReport()" title="Download as PDF">
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>
        <img
          @click="getBoxOfficeReceiptReport('Y')"
          src="@/assets/img/icons/excel.svg"
          height="25"
          width="25"
        />
        <!--<a href="#" @click="excelDownload()" title="Download as Excel">
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a> -->
      </div>

      <!--Pdf File-->
      <div class="d-none">
        <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :paginate-elements-by-height="1400"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="100%"
          ref="html2Pdf"
          @beforeDownload="beforeDownload($event)"
        >
          <div slot="pdf-content">
            <div>
              <div class="table-scroll">
                <div class="d-flex mb-3 flex-wrap justify-content-between">
                  <span
                    ><span class="font-weight-bold">Cinema Name:</span>
                    {{ dropDown.selectedCinemaName }}</span
                  >
                  <div class="ml-5">
                    <span
                      ><span class="font-weight-bold">From Date:</span>
                      {{ fromDate | dateparse }}</span
                    >
                    <span class="ml-2"
                      ><span class="font-weight-bold">To Date:</span>
                      {{ toDate | dateparse }}</span
                    >
                  </div>
                  <div class="d-flex mt-4">
                    <span class="font-weight-bold">Generated At:</span>
                    <span class="ml-1">{{ moment().format("llll") }}</span>
                  </div>
                </div>
                <div class="section-title mb-2 mt-5">
                  {{ $t("Bo & Fnb Report") }}
                </div>
                <table
                  class="swc-report-table swc_table_header"
                  border="1"
                  v-if="getBoxOfficeReport.length > 0"
                >
                  <thead class="bg-lightgrey font-weight-bold">
                    <th>Payment Type</th>
                    <th>Gross</th>
                    <th>Refunds</th>
                    <th>Net</th>
                  </thead>

                  <tr>
                    <td
                      colspan="4"
                      class="text-left bg-lightgrey font-weight-bold"
                    >
                      Box Office
                    </td>
                  </tr>

                  <template
                    v-for="(
                      boxOfficeData, boxOfficeIndex
                    ) in getBoxOfficeReport"
                  >
                    <tr :key="boxOfficeIndex + 'boxOffice'">
                      <td class="text-left">
                        {{ boxOfficeData.pm_payment_mode }}
                      </td>
                      <td class="text-right">
                        {{
                          getFinalGross(boxOfficeData).toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          boxOfficeData.t_refunded_amount.toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          (
                            getFinalGross(boxOfficeData) -
                            boxOfficeData.t_refunded_amount
                          ).toFixed(MIN_FRACTION_DIGITS)
                        }}
                      </td>
                    </tr>
                  </template>

                  <tr class="text-left bg-lightgrey font-weight-bold">
                    <td class="text-left">Grand Total</td>
                    <td class="text-right">
                      {{
                        getBoxOfficeReport
                          .reduce((acc, trx) => {
                            return acc + getFinalGross(trx);
                          }, 0)
                          .toFixed(MIN_FRACTION_DIGITS)
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        getBoxOfficeReport
                          .reduce((acc, { t_refunded_amount }) => {
                            return acc + t_refunded_amount;
                          }, 0)
                          .toFixed(MIN_FRACTION_DIGITS)
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        getBoxOfficeReport
                          .reduce((acc, trx) => {
                            return (
                              acc +
                              (getFinalGross(trx) -
                                (trx.t_refunded_amount || 0))
                            );
                          }, 0)
                          .toFixed(MIN_FRACTION_DIGITS)
                      }}
                    </td>
                  </tr>
                  <tr v-if="getBoxOfficeFnBReport.length > 0">
                    <td colspan="4"></td>
                  </tr>
                  <tr v-if="getBoxOfficeFnBReport.length > 0">
                    <td
                      colspan="4"
                      class="text-left bg-lightgrey font-weight-bold"
                    >
                      FNB
                    </td>
                  </tr>
                  <template
                    v-for="(fnbData, fnbIndex) in getBoxOfficeFnBReport"
                  >
                    <tr :key="fnbIndex + 'fnb'">
                      <td class="text-left">{{ fnbData.pm_payment_mode }}</td>
                      <td class="text-right">
                        {{
                          getFinalGross(fnbData).toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          fnbData.t_refunded_amount.toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          (
                            getFinalGross(fnbData) - fnbData.t_refunded_amount
                          ).toFixed(MIN_FRACTION_DIGITS)
                        }}
                      </td>
                    </tr>
                  </template>
                  <tr
                    class="text-left bg-lightgrey font-weight-bold"
                    v-if="getBoxOfficeFnBReport.length > 0"
                  >
                    <td class="text-left">Grand Total</td>

                    <td class="text-right">
                      {{
                        getBoxOfficeFnBReport
                          .reduce((acc, trx) => {
                            return acc + getFinalGross(trx);
                          }, 0)
                          .toFixed(MIN_FRACTION_DIGITS)
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        getBoxOfficeFnBReport
                          .reduce((acc, { t_refunded_amount }) => {
                            return acc + t_refunded_amount;
                          }, 0)
                          .toFixed(MIN_FRACTION_DIGITS)
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        getBoxOfficeFnBReport
                          .reduce((acc, trx) => {
                            return (
                              acc +
                              (getFinalGross(trx) -
                                (trx.t_refunded_amount || 0))
                            );
                          }, 0)
                          .toFixed(MIN_FRACTION_DIGITS)
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <hr />
            <div class="d-flex mt-2 justify-content-between">
              <div class="section-title">{{ $t("Receipt Report") }}</div>
            </div>

            <table
              v-if="getPaymentArray.length != 0"
              class="swc-report-table swc_table_header mt-2"
              border="1"
            >
              <thead class="bg-lightgrey font-weight-bold">
                <th>Payment Type</th>
                <th>Gross</th>
                <th>Refunds</th>
                <th>Net</th>
              </thead>
              <tbody>
                <template
                  v-for="(paymentTotal, paymentTotalIndex) in getPaymentArray"
                >
                  <tr :key="paymentTotalIndex + 'summary'">
                    <td class="text-left">
                      {{ paymentTotal.pm_payment_mode }}
                    </td>
                    <td class="text-right">
                      {{
                        getFinalGross(paymentTotal).toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        paymentTotal.t_refunded_amount.toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        parseFloat(
                          parseFloat(getFinalGross(paymentTotal)).toFixed(
                            MIN_FRACTION_DIGITS
                          ) -
                            parseFloat(paymentTotal.t_refunded_amount).toFixed(
                              2
                            )
                        ).toFixed(MIN_FRACTION_DIGITS)
                      }}
                    </td>
                  </tr>
                </template>
                <tr class="bg-lightgrey text-right font-weight-bold">
                  <td></td>
                  <td>
                    {{
                      getPaymentArray
                        .reduce((acc, trx) => {
                          return acc + getFinalGross(trx);
                        }, 0)
                        .toFixed(MIN_FRACTION_DIGITS)
                    }}
                  </td>
                  <td>
                    {{
                      getPaymentArray
                        .reduce((acc, { t_refunded_amount }) => {
                          return acc + t_refunded_amount;
                        }, 0)
                        .toFixed(MIN_FRACTION_DIGITS)
                    }}
                  </td>
                  <td>
                    {{
                      getPaymentArray
                        .reduce((acc, trx) => {
                          return (
                            acc -
                            ((trx.t_refunded_amount || 0) - getFinalGross(trx))
                          );
                        }, 0)
                        .toFixed(MIN_FRACTION_DIGITS)
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </vue-html2pdf>
      </div>
      <!--Pdf File End-->

      <!--Excel Export-->

      <table
        class="swc-report-table swc_table_header d-none"
        border="1"
        ref="exportable_table"
        v-if="getBoxOfficeReport.length > 0"
      >
        <tr>
          <td>
            <span class="font-weight-bold">Cinema Name:</span>
            <span>{{ dropDown.selectedCinemaName }} </span>
          </td>
          <td>
            <span
              ><span class="font-weight-bold">From Date:</span>
              {{ fromDate | dateparse }}</span
            >
          </td>
          <td>
            <span class="ml-2"
              ><span class="font-weight-bold">To Date:</span>
              {{ toDate | dateparse }}</span
            >
          </td>
          <td>
            <span class="font-weight-bold">Generated At:</span>
            <span class="ml-1">{{ moment().format("llll") }}</span>
          </td>
        </tr>
        <tr>
          <td></td>
        </tr>
        <tr>
          <td colspan="4">{{ $t("Bo & Fnb Report") }}</td>
        </tr>

        <tr class="bg-lightgrey font-weight-bold">
          <td>Payment Type</td>
          <td>Gross</td>
          <td>Refunds</td>
          <td>Net</td>
        </tr>

        <tr>
          <td colspan="4" class="text-left bg-lightgrey font-weight-bold">
            Box Office
          </td>
        </tr>

        <template v-for="(boxOfficeData, boxOfficeIndex) in getBoxOfficeReport">
          <tr :key="boxOfficeIndex + 'boxOffice'">
            <td class="text-left">{{ boxOfficeData.pm_payment_mode }}</td>
            <td class="text-right">
              {{
                getFinalGross(boxOfficeData).toFixed(MIN_FRACTION_DIGITS)
              }}
            </td>
            <td class="text-right">
              {{
                boxOfficeData.t_refunded_amount.toFixed(
                  MIN_FRACTION_DIGITS
                )
              }}
            </td>
            <td class="text-right">
              {{
                (
                  getFinalGross(boxOfficeData) - boxOfficeData.t_refunded_amount
                ).toFixed(MIN_FRACTION_DIGITS)
              }}
            </td>
          </tr>
        </template>

        <tr v-if="getBoxOfficeFnBReport.length > 0">
          <td colspan="4"></td>
        </tr>
        <tr v-if="getBoxOfficeFnBReport.length > 0">
          <td colspan="4" class="text-left bg-lightgrey font-weight-bold">
            FNB
          </td>
        </tr>
        <template v-for="(fnbData, fnbIndex) in getBoxOfficeFnBReport">
          <tr :key="fnbIndex + 'fnb'">
            <td class="text-left">{{ fnbData.pm_payment_mode }}</td>
            <td class="text-right">
              {{ getFinalGross(fnbData).toFixed(MIN_FRACTION_DIGITS) }}
            </td>
            <td class="text-right">
              {{ fnbData.t_refunded_amount.toFixed(MIN_FRACTION_DIGITS) }}
            </td>
            <td class="text-right">
              {{
                (getFinalGross(fnbData) - fnbData.t_refunded_amount).toFixed(
                  MIN_FRACTION_DIGITS
                )
              }}
            </td>
          </tr>
        </template>
        <tr>
          <td></td>
        </tr>
        <tr>
          <td colspan="4">
            {{ $t("Receipt Report") }}
          </td>
        </tr>
        <tr>
          <td></td>
        </tr>
        <tr>
          <td>Payment Type</td>
          <td>Gross</td>
          <td>Refunds</td>
          <td>Net</td>
        </tr>
        <tbody>
          <template
            v-for="(paymentTotal, paymentTotalIndex) in getPaymentArray"
          >
            <tr :key="paymentTotalIndex + 'summary'">
              <td class="text-left">{{ paymentTotal.pm_payment_mode }}</td>
              <td class="text-right">
                {{
                  getFinalGross(paymentTotal).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td class="text-right">
                {{
                  paymentTotal.t_refunded_amount.toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(
                    parseFloat(getFinalGross(paymentTotal)).toFixed(
                      MIN_FRACTION_DIGITS
                    ) -
                      parseFloat(paymentTotal.t_refunded_amount).toFixed(
                        MIN_FRACTION_DIGITS
                      )
                  ).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <!--Excel Export End-->

      <div>
        <div>
          <div class="section-title mb-3">{{ $t("Bo & Fnb Report") }}</div>
          <div class="table-scroll">
            <table
              class="swc-report-table swc_table_header"
              border="1"
              v-if="getBoxOfficeReport.length > 0"
            >
              <thead class="bg-lightgrey font-weight-bold">
                <th>Payment Type</th>
                <th>Gross</th>
                <th>Refunds</th>
                <th>Net</th>
              </thead>

              <tr>
                <td colspan="4" class="text-left bg-lightgrey font-weight-bold">
                  Box Office
                </td>
              </tr>

              <template
                v-for="(boxOfficeData, boxOfficeIndex) in getBoxOfficeReport"
              >
                <tr :key="boxOfficeIndex + 'boxOffice'">
                  <td class="text-left">{{ boxOfficeData.pm_payment_mode }}</td>
                  <td class="text-right">
                    {{
                      getFinalGross(boxOfficeData).toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      boxOfficeData.t_refunded_amount.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      (
                        getFinalGross(boxOfficeData) -
                        boxOfficeData.t_refunded_amount
                      ).toFixed(MIN_FRACTION_DIGITS)
                    }}
                  </td>
                </tr>
              </template>

              <tr class="text-left bg-lightgrey font-weight-bold">
                <td class="text-left">Grand Total</td>
                <td class="text-right">
                  {{
                    getBoxOfficeReport
                      .reduce((acc, trx) => {
                        return acc + getFinalGross(trx);
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getBoxOfficeReport
                      .reduce((acc, { t_refunded_amount }) => {
                        return acc + t_refunded_amount;
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getBoxOfficeReport
                      .reduce((acc, trx) => {
                        return (
                          acc +
                          (getFinalGross(trx) - (trx.t_refunded_amount || 0))
                        );
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
              </tr>
              <tr v-if="getBoxOfficeFnBReport.length > 0">
                <td colspan="4"></td>
              </tr>
              <tr v-if="getBoxOfficeFnBReport.length > 0">
                <td colspan="4" class="text-left bg-lightgrey font-weight-bold">
                  FNB
                </td>
              </tr>
              <template v-for="(fnbData, fnbIndex) in getBoxOfficeFnBReport">
                <tr :key="fnbIndex + 'fnb'">
                  <td class="text-left">{{ fnbData.pm_payment_mode }}</td>
                  <td class="text-right">
                    {{
                      getFinalGross(fnbData).toFixed(MIN_FRACTION_DIGITS)
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      fnbData.t_refunded_amount.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      (
                        getFinalGross(fnbData) - fnbData.t_refunded_amount
                      ).toFixed(MIN_FRACTION_DIGITS)
                    }}
                  </td>
                </tr>
              </template>
              <tr
                class="text-left bg-lightgrey font-weight-bold"
                v-if="getBoxOfficeFnBReport.length > 0"
              >
                <td class="text-left">Grand Total</td>

                <td class="text-right">
                  {{
                    getBoxOfficeFnBReport
                      .reduce((acc, trx) => {
                        return acc + getFinalGross(trx);
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getBoxOfficeFnBReport
                      .reduce((acc, { t_refunded_amount }) => {
                        return acc + t_refunded_amount;
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getBoxOfficeFnBReport
                      .reduce((acc, trx) => {
                        return (
                          acc +
                          (getFinalGross(trx) - (trx.t_refunded_amount || 0))
                        );
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <table
          v-if="getBoxOfficeReport.length === 0"
          class="swc-report-table swc_table_header"
          border="1"
        >
          <thead class="bg-lightgrey font-weight-bold">
            <th>Payment Type</th>
            <th>Gross</th>
            <th>Refunds</th>
            <th>Net</th>
          </thead>
          <tbody>
            <tr>
              <td colspan="11">
                <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
        <hr />
        <div class="d-flex mt-2 justify-content-between">
          <div class="section-title">{{ $t("Receipt Report") }}</div>
          <div
            class="d-flex justify-content-end align-items-center"
            v-if="getBoxOfficeReport.length"
          >
            <!-- <div class="mx-1">{{ $t("download") }} as:</div> -->
            <!-- <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->
            <!-- <a href="#" @click="excelDownloadSummary()" title="Download as Excel">
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a> -->
          </div>
        </div>

        <table
          v-if="getPaymentArray.length != 0"
          class="swc-report-table swc_table_header mt-2"
          border="1"
        >
          <thead class="bg-lightgrey font-weight-bold">
            <th>Payment Type</th>
            <th>Gross</th>
            <th>Refunds</th>
            <th>Net</th>
          </thead>
          <tbody>
            <template
              v-for="(paymentTotal, paymentTotalIndex) in getPaymentArray"
            >
              <tr :key="paymentTotalIndex + 'summary'">
                <td class="text-left">{{ paymentTotal.pm_payment_mode }}</td>
                <td class="text-right">
                  {{
                    getFinalGross(paymentTotal).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    paymentTotal.t_refunded_amount.toFixed(
                    MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(
                      parseFloat(getFinalGross(paymentTotal)).toFixed(
                        MIN_FRACTION_DIGITS
                      ) -
                        parseFloat(paymentTotal.t_refunded_amount).toFixed(
                          MIN_FRACTION_DIGITS
                        )
                    ).toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
              </tr>
            </template>
            <tr class="bg-lightgrey text-right font-weight-bold">
              <td class="text-left">Grand Total</td>
              <td>
                {{
                  getPaymentArray
                    .reduce((acc, trx) => {
                      return acc + getFinalGross(trx);
                    }, 0)
                    .toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td>
                {{
                  getPaymentArray
                    .reduce((acc, { t_refunded_amount }) => {
                      return acc + t_refunded_amount;
                    }, 0)
                    .toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td>
                {{
                  getPaymentArray
                    .reduce((acc, trx) => {
                      return (
                        acc -
                        ((trx.t_refunded_amount || 0) - getFinalGross(trx))
                      );
                    }, 0)
                    .toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
            </tr>
          </tbody>
        </table>

        <table
          v-if="getPaymentArray.length === 0"
          class="swc-report-table swc_table_header mt-3"
          border="1"
        >
          <thead class="bg-lightgrey font-weight-bold">
            <th>Payment Type</th>
            <th>Gross</th>
            <th>Refunds</th>
            <th>Net</th>
          </thead>
          <tbody>
            <tr>
              <td colspan="11">
                <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import * as XLSX from "xlsx";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      htmlToPdfOptions: {
        filename: "Box Office Receipt Report",
        margin: 3,
        image: {
          type: "jpeg",
          quality: 2,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a4",
          orientation: "portrait",
        },
      },
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      getBoxOfficeReport: [],
      getBoxOfficeFnBReport: [],
      getPaymentArray: [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
  },
  mounted() {},
  methods: {
    // formatColumn(worksheet, col, fmt) {
    //   const range = XLSX.utils.decode_range(worksheet['!ref'])
    //   // note: range.s.r + 1 skips the header row
    //   for (let row = range.s.r + 1; row <= range.e.r; ++row) {
    //     const ref = XLSX.utils.encode_cell({ r: row, c: col })
    //     if (worksheet[ref] && worksheet[ref].t === 'n') {
    //       worksheet[ref].z = fmt
    //     }
    //   }
    // },
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "Receipt Summary" });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : // XLSX.insert_image('B12', 'python.png', {'x_offset': 15, 'y_offset': 10})
          XLSX.writeFile(wb, fn || "ReceiptSummary." + (type || "xlsx"));
    },
    moment,
    async beforeDownload({ html2pdf, options, pdfContent }) {
      // const date = new Date();
      let cinemaName = this.dropDown.selectedCinemaName;
      let fromDate = this.fromDate
        ? moment(this.fromDate).format("YYYY-MM-DD")
        : null;
      let toDate = this.toDate
        ? moment(this.toDate).format("YYYY-MM-DD")
        : null;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      this.pdfFileName =
        "Receipt Summary Report" +
        `_${cinemaName}_${fromDate}_${toDate}_on${dateTime}`;
      this.htmlToPdfOptions.filename = this.pdfFileName;
      await html2pdf()
        .set(this.htmlToPdfOptions)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(12);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },
    generateReport() {
      this.$refs.html2Pdf &&
        this.$refs.html2Pdf.generatePdf &&
        this.$refs.html2Pdf.generatePdf();
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getBoxOfficeReceiptReport: function (isExcel = "N") {
      let loader = this.$loading.show();
      this.submitted = true;
      this.getBoxOfficeReport = [];
      this.getBoxOfficeFnBReport = [];
      this.getPaymentArray = [];

      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        from_date: moment(this.fromDate).format("YYYY-MM-DD"),
        to_date: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
      };
      ReportsService.GetBoxOfficeReceiptReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.excelPath) {
            window.open(data.excelPath);
          }
          if (data.status) {
            // console.log("data from api", data.Records);
            this.getBoxOfficeReport = data.boxOffice_Records || [];
            this.getBoxOfficeFnBReport = data.fnb_Records || [];
            this.getPaymentArray = data.payment_check_array || [];
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 660);
        });
    },
    excelDownload() {
      let new_records = [
        ...this.getBoxOfficeReport,
        ...this.getBoxOfficeFnBReport,
        ...this.getPaymentArray,
      ];

      let data = [
        {
          sheet: "BoxOfficeReceiptReport Report",
          columns: [
            {
              value: "bs_source",
              label: "Booking Source",
            },
            {
              value: "pm_payment_mode",
              label: "Payment Mode",
            },
            {
              value: (row) =>
                this.getFinalGross(row).toFixed(MIN_FRACTION_DIGITS),
              label: "Gross Ampount",
            },
            {
              value: (row) =>
                row.t_refunded_amount.toFixed(MIN_FRACTION_DIGITS),
              label: "Refund Amount",
            },
            {
              value: (row) =>
                (this.getFinalGross(row) - row.t_refunded_amount).toFixed(
                  MIN_FRACTION_DIGITS
                ),
              label: "Net Amount",
            },
          ],
          content: new_records,
        },
      ];
      let settings = {
        fileName: `ReceiptReport${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },

    excelDownloadSummary() {
      let new_records = this.getPaymentArray;
      console.log("new_records", new_records);
      let data = [
        {
          sheet: "Receipt Report Summary",
          columns: [
            {
              value: "pm_payment_mode",
              label: "Payment Type",
            },
            {
              value: (row) =>
                this.getFinalGross(row).toFixed(MIN_FRACTION_DIGITS),
              label: "Gross",
            },
            {
              value: (row) =>
                row.t_refunded_amount.toFixed(MIN_FRACTION_DIGITS),
              label: "Refunds",
            },
            {
              value: (row) =>
                parseFloat(
                  parseFloat(this.getFinalGross(row)).toFixed(
                    MIN_FRACTION_DIGITS
                  ) -
                    parseFloat(row.t_refunded_amount).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                ).toFixed(MIN_FRACTION_DIGITS),
              label: "Net",
            },
          ],
          content: new_records,
        },
      ];
      let settings = {
        fileName: `ReceiptReportSummary${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },

    getFinalGross(trx) {
      if (!trx) return 0;

      let gross =
        (trx.t_gross_amount || 0) +
        (trx.internet_handling_fee || 0) +
        (trx.t_add_ons_charge || 0);

      if (!gross) {
        console.log({ trx });
      }

      return gross;
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/boxOfficeReceiptReport.vue